import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { I18NService } from 'src/core/services/i18n/i18n.service';

@Component({
    selector: 'app-init',
    templateUrl: './init.component.html',
    styleUrls: ['./init.component.scss'],
})
export class InitComponent {
    coffeeQr = false;

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private i18n: I18NService) {
        if (this.activatedRoute.snapshot.routeConfig.path === 'coffee-qr') {
            this.coffeeQr = true;
        }
        if (this.i18n.currentLang === 'sv') {
            this.router.navigateByUrl(`/kaffe${this.coffeeQr ? '?ref=coffee-qr' : ''}`);
        } else {
            this.router.navigateByUrl(`/coffee${this.coffeeQr ? '?ref=coffee-qr' : ''}`);
        }
    }
}
